import { useRef, useState } from 'react'

export const useRerender = () => {
  const [, setState] = useState<any>()
  const ref = useRef<() => void>()
  ref.current ??= () => setState({})
  return ref.current
}
